import { useEffect, useState, useTransition } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useResponsive } from "../../hooks/mediaQuery";
import { ListFilter } from 'lucide-react';
import { FilterField } from "../../models/types/common";
import PageFilter from "../../components/pageFilter";
import * as yup from "yup";
import { useLookupParameterUnit } from "../../utils/get-lookup";
import { convertToSelectOptionsFilter } from "../../utils/helper";
import { useTranslation } from 'react-i18next';

const ParameterFilterView = () => {
    const { t } = useTranslation()
    const { isXs } = useResponsive();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const { lookupParameterUnit } = useLookupParameterUnit();

    const filterFields: FilterField[] = [
        {
            name: "name",
            type: "text",
            label: t('parameter.filter.fields.name.label'),
            placeholder: t('parameter.filter.fields.name.placeholder'),
        },
        {
            name: "unitId",
            type: "select",
            label: t('parameter.filter.fields.unit.label'),
            placeholder: t('parameter.filter.fields.unit.placeholder'),
            options: convertToSelectOptionsFilter(lookupParameterUnit),
        }
    ];

    const filterSchema = yup.object({
        name: yup.string().nullable(),
        unitId: yup.string().nullable(),
    });

    useEffect(() => {
        setIsOpen(!isXs);
    }, [isXs]);

    const onClose = () => {
        setIsOpen(false);
    };

    if (isXs) return (
        <>
            <div
                onClick={() => setIsOpen(true)}
                className="flex items-center gap-2 rounded-full border bg-indigo-600 p-[2px_12px_4px_12px] cursor-pointer"
            >
                <ListFilter size={16} color="white" />
                <span className="text-white">{t('parameter.filter.button')}</span>
            </div>
            <Dialog
                open={isOpen}
                onClose={onClose}
                maxWidth="lg"
                fullWidth
                className='dialog_camera'
            >
                <DialogTitle className="!p-2">
                    {t('parameter.filter.title')}
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 5,
                            top: 5,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ background: '#000' }}>
                    <PageFilter
                        fields={filterFields}
                        validationSchema={filterSchema}
                        onSuccess={onClose}
                    />
                </DialogContent>
            </Dialog>
        </>
    );

    return (
        <PageFilter
            fields={filterFields}
            validationSchema={filterSchema}
        />
    );
}

export default ParameterFilterView